<div class="post-user-categories-list-container">
  <ul *ngIf="formGroup && companyCategory$ | async as cat">
    <app-category
      *ngFor="let category of cat.categories"
      [category]="category"
      [categoryForm]="formGroup"
    >
    </app-category>
  </ul>
</div>
